import { useCMSYAUTHstore } from '@/service/stores/cm/cmsy/AUTH.store'
import { gfnSysDate } from '@/utils/helper/date.helper'

/**
 * 화면 이동할 때마다 서버 시간 가져오고 스토어에 저장.
 * UI 컴포넌트에서 서버 시간 사용하기 위해 만들어짐.
 */
export function createSysDateGuard(router) {
  router.beforeEach(() => {
    execGuard()
  })
}

const execGuard = async () => {
  const CMSYAUTHstore = useCMSYAUTHstore()
  CMSYAUTHstore.cachedSysDate = await gfnSysDate()
}
